import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import './App.css'
import Home from './pages/Home'
import Articles from './pages/Articles'
import Article from './pages/Article'
import Categories from './pages/Categories'
import About from './pages/About'
import Contact from './pages/Contact'
import NotFound from './pages/NotFound'

function App() {
  return (
    <Router>
      <div className="App bg-gray-50 min-h-screen">
        <nav className="bg-primary text-white p-4 shadow-lg">
          <div className="container mx-auto flex gap-6 items-center">
            <Link to="/" className="text-xl font-bold hover:underline">Test Company</Link>
            <Link to="/" className="hover:underline">Home</Link>
            <Link to="/articles" className="hover:underline">Articles</Link>
            <Link to="/article" className="hover:underline">Article</Link>
            <Link to="/categories" className="hover:underline">Categories</Link>
            <Link to="/about" className="hover:underline">About</Link>
            <Link to="/contact" className="hover:underline">Contact</Link>
          </div>
        </nav>
        <main className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/article" element={<Article />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        </main>
        <footer className="bg-gray-800 text-white p-8 mt-16">
          <div className="container mx-auto text-center">
            <p>&copy; {new Date().getFullYear()} Test Company. All rights reserved.</p>
            
          </div>
        </footer>
      </div>
    </Router>
  )
}

export default App
